<script setup>
const props = defineProps({
	iconName: {
		type: String,
		default: null,
	},
});
</script>

<template>
	<a class="i-link" @click="startRefund">
		<svg v-if="iconName">
			<use :xlink:href="`#${iconName}`"></use>
		</svg>
		<slot></slot>
	</a>
</template>

<style scoped lang="scss">
@import "frontend/web/src/styles/utils/variables.scss";
@import "./i-link.scss";
</style>
